/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'

import Chart from '../Chart'
import MarkdownText from '../MarkdownText'
import { DashboardItemProps } from '../types'
import {
    BoardContainer,
    BoardStatistics,
    BoardStats,
    BoardGoals,
    BoardChart,
    BoardStat,
} from './Board.styled'

function Board({ componentStyle, data }: DashboardItemProps) {
    return (
        <BoardContainer componentStyle={componentStyle}>
            <BoardStatistics>
                <h5>
                    {data.statistics.title}
                    <small>{data.statistics.label}</small>
                </h5>
                <BoardStats>
                    {data.statistics.items.map((stat: any, index: number) => {
                        return (
                            <BoardStat key={index}>
                                <strong>{stat.value}</strong>
                                <span>{stat.label}</span>
                            </BoardStat>
                        )
                    })}
                </BoardStats>
                <BoardGoals>
                    {data.goals &&
                        data.goals.lines.map((line: string, i: number) => (
                            <MarkdownText key={i} text={line} />
                        ))}
                </BoardGoals>
            </BoardStatistics>
            <BoardChart>
                <h5>
                    {data.chart.title}
                    <small>
                        <strong>{data.chart.totalFunded}</strong>{' '}
                        {data.chart.label}
                    </small>
                </h5>
                <Chart data={data.chart.data} />
            </BoardChart>
            <footer>
                <h5>{data.footer.title}</h5>
                {data.footer.stats.map((stat: any, index: number) => {
                    return (
                        <div className="stat" key={index}>
                            <b>{stat.title}</b>
                            <strong>{stat.value}</strong>
                            <span>{stat.description}</span>
                        </div>
                    )
                })}
            </footer>
        </BoardContainer>
    )
}

export default Board
